<template>
  <div class="position-relative mx-4 px-4 px-sm-2">
    <Proposition65WarningSymbol :left="xs ? 0 : -10" :top="4" />
    <p class="dont-break-out pt-1 pt-sm-0" :class="xs ? 'font-size-xs' : ''">
      WARNING: This product can expose you to chemicals including tobacco smoke,
      which is known to the State of California to cause cancer and birth
      defects or other reproductive harm. For more information go to
      <a href="https://www.P65Warnings.ca.gov/" target="_blank" rel="noreferrer"
        >https://www.P65Warnings.ca.gov/</a
      >
    </p>
  </div>
</template>
<script>
import Proposition65WarningSymbol from "@/components/UI/Proposition65WarningSymbol.vue";

export default {
  name: "TobaccoWarning",
  components: {
    Proposition65WarningSymbol,
  },
  props: { xs: Boolean },
};
</script>

